export default __webpack_public_path__ + "static/media/lockset-masterImage.451e8762.jpg";